import FormController from '../components/form_controller';

export default class extends FormController {
  // Tiny controller to allow toggles to submit to BE
  submit() { this.formTarget.requestSubmit(); }
}
